import { useState } from "react";
import { FOLDED_BY_DEFAULT, type PropGroup } from "./propLayout";

const KEY = "drang.panel.folds";

function read(): Partial<Record<PropGroup, boolean>> {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? "{}") as Partial<Record<PropGroup, boolean>>;
  } catch {
    return {};
  }
}

/**
 * Which groups of the task panel are open: per device, for every task, changed only by the person's
 * own click on a group's header (spec §9.19 no surprises).
 */
export function useFold(): [(g: PropGroup) => boolean, (g: PropGroup) => void] {
  const [state, setState] = useState(read);
  const isOpen = (g: PropGroup) => state[g] ?? !FOLDED_BY_DEFAULT.includes(g);
  const toggle = (g: PropGroup) => {
    const next = { ...state, [g]: !isOpen(g) };
    setState(next);
    try {
      localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
      /* a convenience only */
    }
  };
  return [isOpen, toggle];
}
